import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { find } from 'lodash'
import { matchPath, useLocation } from 'react-router-dom'

import { routes } from '../../imports/config.js'

import styles from './Footer.module.scss'

import Logo from '../customIcons/Logo'
import Facebook from '../customIcons/Facebook'
import Linkedin from '../customIcons/Linkedin'

const Footer = () => {
    const { t } = useTranslation()
    const location = useLocation()

    const actualPath = find(routes, route =>
        matchPath(location.pathname, { path: route.path, exact: true })
    )

    const socials = [
        {
            name: 'Facebook',
            icon: Facebook,
            url: 'https://www.facebook.com/YupikService',
        },
        {
            name: 'Linkedin',
            icon: Linkedin,
            url: 'https://www.linkedin.com/company/yupikservice/',
        },
    ]

    return (
        <footer
            className={`${styles.footer} ${
                actualPath.hasBottomMenu && styles.bottomMenu
            }`}
        >
            <div className={styles.footerContainer}>
                <section className={`${styles.section} ${styles.copyright}`}>
                    <span className={styles.wrapperLogo}>
                        <Logo className={styles.icon} />
                    </span>
                </section>
                <section className={`${styles.section} ${styles.socials}`}>
                    <span className={styles.wrapperSocials}>
                        <header className={styles.header}>
                            <h2 className={styles.title}>
                                {t('follow_us_on_social_media')}
                            </h2>
                        </header>
                        <ul className={styles.list}>
                            {socials.map(social => {
                                const SocialIcon = social.icon
                                return (
                                    <a
                                        key={social.name}
                                        href={social.url}
                                        className={styles.link}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        <li className={styles.social}>
                                            <SocialIcon
                                                className={styles.icon}
                                            />
                                        </li>
                                    </a>
                                )
                            })}
                        </ul>
                    </span>
                </section>
                <section className={`${styles.section} ${styles.terms}`}>
                    <span className={styles.wrapperTerms}>
                        <Link
                            to='/terms-and-conditions'
                            className={styles.link}
                        >
                            <p className={styles.text}>
                                {t('terms_and_conditions')}
                            </p>
                        </Link>
                        <Link to='/cookies-policy' className={styles.link}>
                            <p className={styles.text}>{t('cookies_policy')}</p>
                        </Link>
                    </span>
                </section>
            </div>
        </footer>
    )
}

export default Footer
